import { useQuery } from "@tanstack/react-query";

import { ListBooksQueryFilters, UseListBooksQueryOptions } from "./types";
import { getBooksService } from "./service";

export const listBooksQueryKey = ["book_admin"];

export function useListBooksQuery(
  filters?: ListBooksQueryFilters,
  options?: UseListBooksQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listBooksQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getBooksService(filters),
    ...options,
  });
}
